import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import {
  listingApi,
} from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';
import {
  cloneDeep,
  forEach,
} from '../../libs/lodash';

import {
  AUTHOR,
} from './constants';

function* storeAuthor(data = {}, merge = true) {
  yield put({
    type: AUTHOR.update,
    data,
    merge,
  });
}

function* fetchAuthor({
  data,
}) {
  yield* storeAuthor(data);
}

function* updateAuthor({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    let id = _id;
    if (_id) {
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'author',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      yield* storeAuthor({
        [data._id]: data,
      });
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'author',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      id = newData._id;
      yield* storeAuthor({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess(id));
  } catch (error) {
    yield* storeAuthor();
    errorHandler('Thất bại', error);
  }
}

function* removeAuthor({
  _id,
}) {
  const {
    author,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'author',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(author.data);
    delete newData[_id];
    yield* storeAuthor(newData, false);

    successHandler('Thành công', 'Xóa thành công');
  } catch (error) {
    yield* storeAuthor();
    errorHandler('Thất bại', error);
  }
}

function* importAuthor({
  data = [],
}) {
  const {
    author,
  } = yield select();
  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'author',
      payload: {
        data,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));
  const newData = cloneDeep(author.data);
  forEach(
    (obj) => {
      newData[obj._id] = obj;
    },
    data,
  );
  yield* storeAuthor(newData);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* authorSaga() {
  yield all([
    yield takeEvery(AUTHOR.handlers.fetch, fetchAuthor),
    yield takeEvery(AUTHOR.handlers.update, updateAuthor),
    yield takeEvery(AUTHOR.handlers.import, importAuthor),
    yield takeEvery(AUTHOR.handlers.remove, removeAuthor),
  ]);
}
